import type {
  Configuration,
  CreateSamlIdentityProviderConfigInput,
  UpdateSamlIdentityProviderInput,
} from '@repo/api-gw-sdk';
import {
  ListSamlIdentityProviderConfigsApi,
  CreateSamlIdentityProviderConfigApi,
  DeleteSamlIdentityProviderConfigApi,
  UpdateSamlIdentityProviderConfigOverrideApi,
  GetServiceProviderDetailsApi,
  AuthApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/samlIdentityProvider';

export const saml = (httpClient: HttpClient, config: Configuration) => {
  const listSamlIdentityProviderConfigsApi =
    new ListSamlIdentityProviderConfigsApi(config);
  const createSamlIdentityProviderConfigApi =
    new CreateSamlIdentityProviderConfigApi(config);
  const updateSamlIdentityProviderConfigOverrideApi =
    new UpdateSamlIdentityProviderConfigOverrideApi(config);
  const deleteSamlIdentityProviderConfigApi =
    new DeleteSamlIdentityProviderConfigApi(config);
  const getServiceProviderDetailsApi = new GetServiceProviderDetailsApi(config);
  const authApi = new AuthApi(config);

  return {
    useList: () =>
      httpClient.execute(
        listSamlIdentityProviderConfigsApi.listSamlIdentityProviderConfigs.bind(
          listSamlIdentityProviderConfigsApi
        ),
        baseUrl,
        ''
      ),
    create: (saml: CreateSamlIdentityProviderConfigInput) =>
      createSamlIdentityProviderConfigApi.createSamlIdentityProviderConfig(
        saml
      ),
    update: (id: string, saml: UpdateSamlIdentityProviderInput) =>
      updateSamlIdentityProviderConfigOverrideApi.updateSamlConfigOverride(
        id,
        saml
      ),
    delete: (id: string) =>
      deleteSamlIdentityProviderConfigApi.deleteSamlIdentityProviderConfig(id),
    useServiceProviderDetails: (providerName?: string) =>
      httpClient.execute(
        getServiceProviderDetailsApi.getServiceProviderDetails.bind(
          getServiceProviderDetailsApi
        ),
        baseUrl,
        'service-provider-details',
        providerName
      ),

    auth: {
      useListIdentityProvidersNames: () =>
        httpClient.execute(
          authApi.listIdentityProvidersNames.bind(authApi),
          baseUrl,
          'provider-names'
        ),
    },
  };
};
